import i18n from "src/i18n/i18n";
import * as Yup from "yup";

export default class InvoiceCombineKey {
    id: number;
    client_id: number;
    invoice_expeditor_id: number;
    identifier: string;
    description: string;

    static getRules(invoiceCombineKey: InvoiceCombineKey) {
        return Yup.object().shape({
            client_id: Yup.number()
                .required(i18n.t("VALIDATION.REQUIRED")),
            invoice_expeditor_id: Yup.number()
                .required(i18n.t("VALIDATION.REQUIRED")),
            identifier: Yup.string()
                .max(10)
                .required(i18n.t("VALIDATION.REQUIRED")),
            description: Yup.string()
                .max(300)
                .required(i18n.t("VALIDATION.REQUIRED")),
        })
    }

    static getInitValues(invoiceCombineKey: InvoiceCombineKey) {
        return {
            client_id: invoiceCombineKey ? invoiceCombineKey.client_id : "",
            invoice_expeditor_id: invoiceCombineKey ? invoiceCombineKey.invoice_expeditor_id : "",
            identifier: invoiceCombineKey ? invoiceCombineKey.identifier : "",
            description: invoiceCombineKey ? invoiceCombineKey.description : "",
        }
    }
}
